import React from 'react';
import styled, { keyframes } from 'styled-components';

// Fade in animation
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

// Bounce animation for social icons
const bounce = keyframes`
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
`;

const FooterContainer = styled.footer`
  margin-top: 60px;
  padding: 40px 0;
  text-align: center;
  border-top: 1px solid rgba(0, 194, 255, 0.3);
  color: #8892b0;
  font-size: 1rem;
  animation: ${fadeIn} 1s ease-out;
  
  @media (max-width: 768px) {
    margin-top: 40px;
    padding: 30px 0;
    font-size: 0.9rem;
  }
  
  @media (max-width: 480px) {
    margin-top: 30px;
    padding: 25px 0;
  }
`;

const FooterText = styled.p`
  margin: 15px 0;
  
  @media (max-width: 768px) {
    margin: 12px 0;
  }
  
  @media (max-width: 480px) {
    margin: 10px 0;
  }
`;

const FooterLink = styled.a`
  color: #64ffda;
  text-decoration: none;
  margin: 0 15px;
  transition: all 0.3s ease;
  padding: 5px 10px;
  border-radius: 4px;
  
  &:hover {
    background: rgba(0, 194, 255, 0.1);
    text-decoration: none;
    transform: translateY(-2px);
  }
  
  @media (max-width: 768px) {
    margin: 0 10px;
  }
  
  @media (max-width: 480px) {
    display: block;
    margin: 8px 0;
  }
`;

const SocialLinks = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  margin: 20px 0;
  
  a {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: rgba(0, 194, 255, 0.1);
    color: #64ffda;
    transition: all 0.3s ease;
    animation: ${bounce} 2s infinite;
    
    &:hover {
      background: linear-gradient(90deg, #00c2ff, #64ffda);
      color: #0c162d;
      transform: translateY(-5px);
    }
  }
  
  @media (max-width: 480px) {
    gap: 15px;
    
    a {
      width: 35px;
      height: 35px;
    }
  }
`;

const Footer = () => {
  return (
    <FooterContainer>
      <SocialLinks>
        <a href="#twitter" aria-label="Twitter" style={{ animationDelay: '0.2s' }}>🐦</a>
        <a href="#facebook" aria-label="Facebook" style={{ animationDelay: '0.4s' }}>📘</a>
        <a href="#linkedin" aria-label="LinkedIn" style={{ animationDelay: '0.6s' }}>👔</a>
        <a href="#instagram" aria-label="Instagram" style={{ animationDelay: '0.8s' }}>📸</a>
      </SocialLinks>
      <FooterText>© {new Date().getFullYear()} UPM Traders. All rights reserved.</FooterText>
      <FooterText>
        <FooterLink href="#privacy">Privacy Policy</FooterLink>
        <FooterLink href="#terms">Terms of Service</FooterLink>
        <FooterLink href="#contact">Contact</FooterLink>
      </FooterText>
      <FooterText>
        Market data is for informational purposes only and should not be considered financial advice.
      </FooterText>
    </FooterContainer>
  );
};

export default Footer;